<template>
  <div id="school-wrapper">
    <a
      class="school-message"
      :href="schoolInfo.informLink"
      target="_blank"
    >
      <img
        :src="schoolInfo.informPicUrl ? schoolInfo.informPicUrl : defaultCover"
        class="message-pic"
      >
      <p class="message-text">{{schoolInfo.informText}}</p>
    </a>
    <!-- 课程展示 -->
    <div class="primary-course">
      <h2 class="primary-title">课程展示</h2>
      <ul class="course-list">
        <li
          v-for="(item,index) in courseList"
          :key="index"
          @click="jumpCourse(item.courseId)"
        >
          <img
            :src="item.courseImage ? item.courseImage : defaultCover"
            :onerror="errorCover"
          >
          <div class="course-text">
            <p>{{item.courseName}}</p>
            <p class="course-tag">{{item.tag}}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 教师风采 -->
    <div class="primary-course">
      <h2 class="primary-title">教师风采</h2>
      <swiper
        class="teacher-list"
        ref="mySwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(item,index) in teacherList"
          :key="index"
        >
          <img :src="item.teacherUrl">
          <div class="course-text">
            <p>{{item.teacherName}}</p>
            <p class="course-tag">{{item.teacherDesc}}</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 学校掠影 -->
    <div class="school-shufty">
      <h2>学校掠影</h2>
      <swiper
        class="teacher-list"
        ref="mySwiper"
        :options="schoolSwiperOptions"
      >
        <swiper-slide
          v-for="(item,index) in schoolPicture"
          :key="index"
        >
         <img :src="item.sketchUrl">
          <p>{{item.sketchTitle}}</p>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { getSchoolCourseListApi, getSchoolTeacherListApi, getSchoolSketchListApi } from '@/api/school'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Swiper2, {Pagination} from 'swiper';
Swiper2.use(Pagination)
import 'swiper/swiper-bundle.min.css'
export default {
  name: "SchoolMoudle",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data () {
    return {
      defaultCover: require('@/assets/images/common/banner.png'),
      schoolDetail: '',
      //课程列表
      courseList: [],
      //老师列表
      teacherList: [],
      //学校掠影
      schoolPicture: [],
      //加载失败展示
      errorCover: 'this.src="' + require('@/assets/images/common/tu.png') + '"',
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      schoolSwiperOptions: {
        spaceBetween: 0,
        slidesPerView: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      }
    }
  },
  computed: {
    schoolInfo () {
      return this.$store.state.schoolInfo.schoolInfo;
    }
  },
  created () {
    this.$store.dispatch('schoolInfo/getSchoolInfo', this.$route.params.id);
  },
  mounted () {
    this.getSchoolCourseList();
    this.getSchoolTeacherList();
    this.getSchoolSketchList();
  },
  methods: {
    //课程列表
    getSchoolCourseList () {
      const params = {
        schoolId: this.$route.params.id
      }
      getSchoolCourseListApi(params).then(data => {
        if (data.success && data.result) {
          this.courseList = data.result;
          this.courseList.map((item) => {
            const tag = item.bookVersion + '、' + item.subjectName + '、' + item.gradeName
            item.tag = tag;
            return item;
          })
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },
    //学校老师
    getSchoolTeacherList () {
      const params = {
        schoolId: this.$route.params.id
      }
      getSchoolTeacherListApi(params).then(data => {
        if (data.success && data.result) {
          this.teacherList = data.result;
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },
    // 学校掠影
    getSchoolSketchList () {
      const params = {
        schoolId: this.$route.params.id
      }
      getSchoolSketchListApi(params).then(data => {
        if (data.success && data.result) {
          this.schoolPicture = data.result;
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },
    jumpCourse (courseId) {
      let { href } = this.$router.resolve({
        path: `/course/` + courseId
      });
      window.open(href, '_blank');
    }
  }
};
</script>
